<template>
    <b-row>
        <b-col>
            <div class="mobile-card">
                <b-row>
                    <b-col cols="10">
                        <p class="mobile-name">Generic Name<span class="mobile-number ps-2"> 32</span></p>
                        <p class="mobile-id">GN00001</p>
                    </b-col>
                    <b-col cols="2" class="d-flex flex-row-reverse">
                        <i class="pi pi-ellipsis-h" style="font-size: 2rem" @click="toggle" aria-haspopup="true"
                            aria-controls="overlay_menu"></i>
                        <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>

</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
export default defineComponent({
    setup() {
        const menu = ref();
        const items = ref([
            {
                items: [
                    {
                        label: 'Edit',
                        icon: 'pi pi-pencil',
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-times',
                    }
                ]
            }
        ]);

        const toggle = (event) => {
            menu.value.toggle(event);
        };
        return {
            menu,
            items,
            toggle
        }
    }
})
</script>

<style>
.mobile-name {
    color: #444444;
    font-size: 16px;
    font-weight: 600;
}

.mobile-id {
    color: #999999;
    font-size: 14px;
}

.mobile-number {
    color: #999999;
    font-size: 14px;
}
</style>